import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import $ from "jquery";
import SideMenu from "../../src/Pages/SideMenu";
import Footer from "../../src/Pages/Footer";
import Header from "../../src/Pages/Header";
import Logout from "../../src/Pages/Logout";
import { strings } from "../Utilities/strings";
import Search from "../images/search.png";
//for fontawesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
//for data table
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "@fortawesome/fontawesome-svg-core/styles.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Edit_Icon from "../images/edit_icon.svg";

//for modal
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal } from "react-bootstrap";
import {
  dailyWorkLogView,
  dailyWorkLogAssignedToMe,
  dailyWorkLogUpdateWork,
  rmGetmasters,
  dailyWorkLogViewById,
} from "../Utilities/URLCONSTANTS";
import {
  HiMiniArrowsUpDown,
  HiMiniArrowUp,
  HiMiniArrowDown,
} from "react-icons/hi2";

// import {Oval as Loader} from 'react-loader-spinner';
import { GetApiHeaders } from "../Utilities/NetworkUtilities";
import UploadImg from "../images/uploadImg.png";
import * as XLSX from "xlsx";
import moment from "moment";
import { USER_PROFILE } from "../Utils";
import Loader_Bulk from "../Utilities/Loader_Bulk";
import { CustomDatePickerInput, customstyles, modalCustomStyles } from "../Utilities/utils";
import Select from "react-select";
import searchIcon from "../images/search_icon.svg";
import DatePicker from "react-datepicker";
import Pagination from "../Utilities/Pagination";

//UnitMeasureMaster
const DailyWorkAllocation = ({ }) => {
  const [loaderImage, setLoaderImage] = useState(
    require("../images/rmloader.gif")
  );
  const [submitResponse, setsubmitResponse] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showResponsePopup, setShowResponsePopup] = useState(false);
  const [id, setId] = useState("");
  const [location, setLocation] = useState("");
  const [subLocation, setSubLocation] = useState();
  const [equipment, setEquipment] = useState("");
  const [date, setDate] = useState("");
  const [assignTo, setAssignTo] = useState("");
  const [workCreatedDate, setWorkCreatedDate] = useState("");
  const [buttonText, setButtonText] = useState("Submit");
  const [status, setStatus] = useState();
  const [remark, setRemark] = useState();
  const [showPopup, setShowPopup] = useState(false);
  const [popupText, setPopupText] = useState(
    "Do you want to close Unit Measure Master"
  );
  const [loading, setLoading] = useState(false);
  const [deleteItems, setDeleteItems] = useState("");
  const [errLocation, setErrLocation] = useState("");
  const [errcorepermit, setErrCorepermit] = useState("");
  const [errorTypeOfWork, setErrorTypeOfWork] = useState("");
  const [errSubLocation, setErrSubLocation] = useState("");
  const [errDate, setErrDate] = useState("");
  const [errEquipment, setErrEquipment] = useState("");
  const [errAssignTo, setErrAssignTo] = useState("");
  const [errWorkCreated, setErrWorkCreated] = useState("");
  const [errRemark, setErrRemark] = useState("");
  const [errStatus, setErrStatus] = useState("");
  const [getData, setGetData] = useState([]);
  const [locationCode, setLocationCode] = useState([]);
  ///modal popup
  const [showModal, setShowModal] = useState(false);
  const [showMsg, setShowMsg] = useState("false");
  const [editValue, setEditValue] = useState();
  const [modalData, setModalData] = useState({
    id: "",
    roleName: "",
    description: "",
    status: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [showWarningPopup, setShowWarningPopup] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]); // For filtered results
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Default: 10 items per page
  const [searchTerm, setSearchTerm] = useState("");
  const [serverRecordId, setServerRecordId] = useState();
  const [selectedItem, setSelectedItem] = useState();
  const [selectedIndex, setSelectedIndex] = useState();
  const [generalList, setGeneralList] = useState([]);
  const [generalWork, setGeneralWork] = useState();
  const [errgeneralWork, setErrGeneralWork] = useState("");
  const [corePermit, setCorePermit] = useState("");
  const [totalItems, setTotalItems] = useState();
  const [fullData, setFullData] = useState([]);
  const [getSubLocations, setGetSubLocations] = useState([]);
  const [getSubLocationsArray, setSubLocationsArray] = useState([]);
  const [getEquipments, setGetEquipments] = useState([]);
  const [getEquipmentsArray, setGetEquipmentsArray] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [assigneName, setAssigneName] = useState("");
  const [assigneMobile, setAssigneMobile] = useState();
  const [assigneUser, setAssigneUser] = useState();
  const [getLogin, setGetLogin] = useState([]);
  const [equipmentName, setEquipmentName] = useState();
  const [subLocationName, setSubLocationName] = useState();
  const [generalName, setGeneralName] = useState();
  const [getAssignedToData, setGetAssignedToData] = useState([]);
  const [technicianRolesList, setTechnicianRolesList] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [filteredTechnicianRoles, setFilteredTechnicianRoles] = useState([]);
  const [errTechnicianRole, setErrTechnicianRole] = useState("");
  const handleFilter = (searchTerm) => {
    setSearchTerm(searchTerm);
    if (data != null && data != undefined) {
      const filteredResults = data.filter((item) => {
        const searchValue = searchTerm.trim().toLowerCase();

        return (
          (item.generalWorks && item.generalWorks.toLowerCase().includes(searchValue)) ||
          (item.corePermitRequired && item.corePermitRequired.toLowerCase().includes(searchValue)) ||
          (item.location && item.location.toLowerCase().includes(searchValue)) ||
          (item.subLocation && item.subLocation.toLowerCase().includes(searchValue)) ||
          (item.equipment && item.equipment.toLowerCase().includes(searchValue)) ||
          (item.newDateFormat &&
            item.newDateFormat.toString().toLowerCase().includes(searchValue)) ||
          (item.technicianShiftName && item.technicianShiftName.toLowerCase().includes(searchValue)) ||
          (item.remarks && item.remarks.toLowerCase().includes(searchValue)) ||
          (item.status && item.status.toLowerCase().includes(searchValue))
        );
      });

      setFilteredData(filteredResults);
      handlePageClick(1);
    }
  };


  useEffect(() => {
    if (data != null && data != undefined) {
      setFilteredData(data);
      setTotalItems(data.length);
    }
    const userProfileJSON = sessionStorage.getItem(USER_PROFILE);
    setGetLogin(JSON.parse(userProfileJSON));
    console.log("User Profile:", JSON.parse(userProfileJSON));
  }, [data, getSubLocationsArray]);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const handleItemsPerPageChange = (e) => {
    const selectedValue = parseInt(e.target.value);
    setItemsPerPage(selectedValue);
    setCurrentPage(1);
  };

  const pageNumbers = [];
  for (
    let i = Math.max(2, currentPage - 1);
    i <= Math.min(Math.ceil(totalItems / itemsPerPage) - 1, currentPage + 1);
    i++
  ) {
    pageNumbers.push(i);
  }

  const handlePageClick = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(totalItems / itemsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const exportToExcel = () => {
    const data = [
      [
        "S.no",
        "General Works",
        "Site",
        "Location",
        "Equipment",
        "Date",
        "Technician Role",
        "Work Created-Date",
        "CorePermit-Required",
        "Remarks",
        "Status",
      ], // Custom headers
      // ...currentItems.map((item) => [
      ...filteredData.map((item, index) => [
        index + 1,
        item.generalWorks,
        item.location,
        item.subLocation,
        item.equipment,
        item.date,
        item.technicianShiftName,
        item.workCreatedDate,
        item.corePermitRequired,
        item.remarks,
        item.status,
      ]),
    ];

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "DailyWork_Allocation");

    // Save the file
    XLSX.writeFile(wb, "DailyWork_Allocation.xlsx");
  };

  const handleCancel_new = () => {
    setShowModal(true);
    setShowPopup(true);
  };
  const closeWarning = () => {
    setShowWarningPopup(true);
  };
  const handleCancel = () => {
    setShowModal(true);
    setShowPopup(false);
    setShowMsg(true);
    // window.location.reload();
  };
  const handleClose = () => {

    setShowPopup(false);
    setShowModal(false);
    window.location.reload();
  };
  const handleModalClose = () => {
    setShowPopup(false);
    setShowModal(false);
    setShowWarningPopup(false);
    window.location.reload();
  };




  const handleresponse = () => {
    setShowResponsePopup(false);
    setShowWarningPopup(false);
    setShowPopup(false);
    setShowModal(false);
    window.location.reload();
  };
  const handleModalOpen = (item, index) => {
    setButtonText("Submit");
    setIsSubmitted(false);
    setIsUpdated(false);
    setShowModal(true);
    setId("");
    setLocation("");
    setSubLocation("");
    setEquipment("");
    setSelectedRole("");
    setDate("");
    setWorkCreatedDate("");
    setRemark("");
    setStatus("");
    setSelectedRole("");
    setModalData({
      id: "",
      location: "",
      subLocation: "",
      equipment: "",
      date: "",
      selectedRole: "",
      workCreatedDate: "",
      remark: "",
      status: "",
    });
    setSelectedItem(item);
    setSelectedIndex(index);
  };

  const handleLocation = (e) => {
    const subLocationsArray = [];
    setLocation(e.target.value);
    const selectedLocation = e.target.options[e.target.selectedIndex].getAttribute("data-location");
    setLocationCode(selectedLocation);
    if (e.target.value) {
      getSubLocations.find((item) => {
        if (item.locationId === parseInt(e.target.value)) {
          subLocationsArray.push(item);
        }
      });
      setSubLocationsArray(subLocationsArray);
      setErrLocation("");
    } else {
      setErrLocation("Select Location");
      setSubLocationsArray([]);
    }
  };

  const handleSubLocation = (e) => {
    setSubLocation(e.target.value);
    const selectedSubLocationName = e.target.options[e.target.selectedIndex].getAttribute("data-subLocationName");
    setSubLocationName(selectedSubLocationName);
    setErrSubLocation("");
  };



  const handleTechnicianRoleList = (e) => {
    const selectedRoleCode = e.target.value;
    setSelectedRole(selectedRoleCode);
    setErrTechnicianRole("");
  };


  const handleEquipment = (e) => {
    const selectedEquipment = e.target.value;
    setEquipment(selectedEquipment);
    const selectedEquipmentName =
      e.target.options[e.target.selectedIndex].getAttribute(
        "data-equipmentName"
      );
    setEquipmentName(selectedEquipmentName);
    if (e.target.value) {
      setErrEquipment("");
    }
  };
  const handleAssignTo = (e) => {
    setAssignTo(e.target.value);
    const selectedName =
      e.target.options[e.target.selectedIndex].getAttribute("data-Name");
    const selectedUser =
      e.target.options[e.target.selectedIndex].getAttribute("data-user");
    const selectedMobile =
      e.target.options[e.target.selectedIndex].getAttribute("data-mobileNo");

    setAssigneMobile(selectedMobile);
    setAssigneName(selectedName);

    setAssigneUser(selectedUser);
    if (e.target.value) {
      setErrAssignTo("");
    }
  };
  const generalSel = useRef(null);

  const tableRef = useRef(null);
  useEffect(() => {
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().destroy();
    }
    $(tableRef.current).DataTable({
      ordering: false,
    });
  }, []);

  const handleGeneralList = (e) => {
    setGeneralWork(e.target.value);
    const selectedGeneralName =
      e.target.options[e.target.selectedIndex].getAttribute(
        "data-generalWorkName"
      );
    setGeneralName(selectedGeneralName);
    setErrorTypeOfWork("");
  };




  const fetchData = async () => {
    const fetchDataApi = dailyWorkLogView;
    const headers = await GetApiHeaders();

    try {
      setIsLoading(true);
      const response = await axios.post(fetchDataApi, {}, { headers });
      console.log("fetchDataResponse: ", response);
      const dailyWorkLog = response.data?.response?.dailyWorkLog || [];
      setData(dailyWorkLog);
      setFullData(dailyWorkLog);
      setIsLoading(false);
    } catch (error) {
      console.log("fetchData Error :", error);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
    getMasterData();
  }, []);
  const getMasterData = async () => {
    const getData = rmGetmasters;
    const headers = await GetApiHeaders();
    try {
      const responseGetData = await axios.get(getData, { headers });
      console.log("resssss,", responseGetData);
      setGetData(responseGetData.data.response.workLogLocation);
      setGeneralList(responseGetData.data.response.generalWorksList);
      setGetSubLocations(responseGetData.data.response.workLogSubLocation);
      setGetEquipments(responseGetData.data.response.workLogEquipment);
      setGetAssignedToData(responseGetData.data.response.employees);
      setTechnicianRolesList(responseGetData.data.response.technicianRolesList);
    } catch (err) {
      console.log("getError", err);
    }
  };
  const handleDate = (e) => {
    setDate(e.target.value);
    if (e.target.value) {
      setErrDate("");
    }
  };
  const handleChecks = (value) => {
    setCorePermit(value);
    if (value) {
      setErrCorepermit("");
    }
  };

  const selectedTechnicianRole = technicianRolesList.find(
    (role) => role.code === parseInt(selectedRole)
  );

  // Check if technician role exists
  const technicianShiftId = selectedTechnicianRole ? selectedTechnicianRole.code : ""; // Use technicianShiftId instead of technicianRoleId
  const technicianShiftName = selectedTechnicianRole ? selectedTechnicianRole.name : "";

  const handleSubmit = async (index) => {
    if (equipment === "") {
      setErrEquipment("Please select Equipment");
    }
    if (location === "") {
      setErrLocation("Please select Site");
    }
    if (date === "") {
      setErrDate("Please select Date");
    }
    if (subLocation === "") {
      setErrSubLocation("Please select Location");
    }
    if (corePermit === "") {
      setErrCorepermit("Please select CorePermit Required");
    }
    if (technicianShiftName === "") {
      setErrorTypeOfWork("Please select TypeOfWork");
    }

    // if (generalWork === "") {
    //   setErrorTypeOfWork("Please select TypeOfWork");
    // } 

    if (selectedRole === "") {
      setErrTechnicianRole("Please select Technician Role");
    }

    const submitApi = dailyWorkLogAssignedToMe;
    const headers = await GetApiHeaders();
    const postData = {
      // assignWorkToId: assignTo,
      // assignWorkToMobileNumber: assigneMobile,
      // assignWorkToName: assigneName,
      assignedByEmpId: getLogin.userId,
      assignedByEmpMobileNumber: getLogin.mobileNumber,
      assignedByEmpName: getLogin.firstName + " " + getLogin.lastName,
      userType: getLogin.roleTypeName,
      date: date,
      equipment: equipmentName,
      equipmentId: equipment,
      location: locationCode,
      locationId: location,
      remarks: remark,
      status: "Assigned",
      subLocationId: subLocation,
      subLocation: subLocationName,
      technicianShiftName: technicianShiftName, // Add technician shift name
      technicianShiftId: technicianShiftId, // Add technician shift id
      submittedDate: moment(new Date()).format("YYYY-MM-DD HH:MM:SS.SSS"),
      generalWorksId: generalWork,
      generalWorks: generalName,
      corePermitRequired: corePermit,
    };
    console.log("postData", postData);

    try {
      if (
        date != "" &&
        selectedRole != "" &&
        location != "" &&
        subLocation != "" &&
        equipment != "" &&
        generalWork != ""
      ) {
        const response = await axios.post(submitApi, postData, { headers });
        console.log("res----------:", response);

        if (response.data.statusCode == 200) {
          setShowResponsePopup(true);
          setsubmitResponse(response.data.message);
        }
        if (response.data.statusCode == 500) {
          setShowResponsePopup(true);
          setsubmitResponse(response.data.message);
        }
        setErrEquipment("");
        setErrDate("");
        setErrLocation("");
        setErrSubLocation("");
        setErrStatus("");
        setErrTechnicianRole("");
        setErrCorepermit("")
        setErrorTypeOfWork("")
        setIsSubmitted(true);
      }
    } catch (error) {
      console.log("error,", error);
    }
  };
  const handleUpdate = async (id, selectedIndex) => {
    var selectedGeneralName = "";
    var updateLocation = "";
    var selectedSublocation = "";
    var updateEquipment = "";
    var updateTechnicianData = "";
    var selectedAssignto = "";
    var selectedMobile = "";
    const updateApi = dailyWorkLogUpdateWork;
    const headers = await GetApiHeaders();
    const serverRecordId = id ? parseInt(id) : null;
    generalList.map((v, i) => {
      if (v.code === parseInt(generalWork)) {
        selectedGeneralName = v.name;
      }
    });

    getData.map((v, i) => {
      if (v.code === parseInt(location)) {
        updateLocation = v.name;
      }
    });
    getSubLocationsArray.map((v, i) => {
      if (v.code === parseInt(subLocation)) {
        selectedSublocation = v.name;
      }
    });
    getEquipments.map((v, i) => {
      if (v.code === parseInt(equipment)) {
        updateEquipment = v.name;
      }
    });
    // technicianRolesList.map((v, i) => {
    //   if (v.code === parseInt(assignTo)) {
    //     selectedAssignto = v.name;
    //     selectedMobile = v.mobileNumber;
    //   }
    // });
    technicianRolesList.map((v, i) => {
      if (v.code === parseInt(selectedRole)) {
        updateTechnicianData = v.name;
      }
    });

    const updateData = {
      // assignWorkToId: assignTo.toString(),
      // assignWorkToMobileNumber: selectedMobile,
      // assignWorkToName: selectedAssignto,
      assignedByEmpId: getLogin.userId,
      assignedByEmpMobileNumber: getLogin.mobileNumber,
      assignedByEmpName: getLogin.firstName + " " + getLogin.lastName,
      userType: getLogin.roleTypeName,
      date: date,
      equipment: updateEquipment,
      equipmentId: equipment,
      location: updateLocation,
      locationId: location,
      remarks: remark,
      status: "Assigned",
      subLocationId: subLocation,
      subLocation: selectedSublocation,
      submittedDate: moment(new Date()).format("YYYY-MM-DD HH:MM:SS.SSS"),
      generalWorksId: generalWork,
      generalWorks: selectedGeneralName,
      corePermitRequired: corePermit,
      serverRecordId: serverRecordId,
      technicianShiftName: technicianShiftName, // Add technician shift name
      technicianShiftId: technicianShiftId,
    };
    console.log("postDataCheck", updateData);
    try {
      const response = await axios.post(updateApi, updateData, { headers });
      console.log("updatedResponse", response);

      if (response.data.statusCode == 200) {
        setShowResponsePopup(true);
        setsubmitResponse(response.data.message);
      }
      if (response.data.statusCode == 500) {
        setShowResponsePopup(true);
        setsubmitResponse(response.data.message);
      } else {
      }
    } catch (error) {
      console.log(error);
    }
  };

  function getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // January is 0
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  const updatedEItems = (item) => {
    setId(item.serverRecordId);
    setSubLocationsArray(getSubLocations);
    setSubLocation(item.subLocation);
    setEquipment(item.equipment);
    setDate(item.date);
    setCorePermit(item.corePermitRequired);
    setGeneralWork(item.generalWorks);
    setAssignTo(item.assignWorkTo);
    setWorkCreatedDate(item.workCreatedDate);
    setRemark(item.remarks);
    setStatus(item.status);
    setShowModal(true);
    setButtonText("Update");
    setIsSubmitted(false);
    setIsUpdated(true);
  };
  const handleEditLocation = (id) => {
    const subLocationsArray = [];
    setLocation(id);
    setLocationCode(id);
    if (id) {
      getSubLocations.find((item) => {
        if (item.locationId === parseInt(id)) {
          subLocationsArray.push(item);
        }
      });
      setSubLocationsArray(subLocationsArray);
      setErrLocation("");
      console.log("subLocationsArray" + JSON.stringify(getSubLocationsArray));
    } else {
      setErrLocation("Select Location");
      setSubLocationsArray([]);
    }
  };
  const handleEditEquipment = (id) => {
    setEquipment(id);
  };
  const handleEditGeneral = (id) => {
    setGeneralWork(id);
  };
  const handleEditSublocation = (id) => {
    const EquipmentArray = [];
    if (id) {
      getEquipments.find((item) => {
        if (item.subLocationId === parseInt(id)) {
          EquipmentArray.push(item);
        }
      });
      setGetEquipmentsArray(EquipmentArray);
      setErrSubLocation("");
      console.log("Equipmnet Array" + JSON.stringify(EquipmentArray));
    } else {
      setErrSubLocation("Select Location");
      setGetEquipmentsArray([]);
    }
  };

  const updatedItems = async (item) => {
    console.log(item, "Selected row data");
    const id = item.serverRecordId;
    setId(id);
    const apiEdit = dailyWorkLogViewById;
    const headers = await GetApiHeaders();

    try {
      const response = await axios.get(`${apiEdit}?id=${id}`, { headers });
      console.log('Response:', response);
      const onEdit = response.data.response.dailyWorkLog[0];

      generalList.map((v) => {
        if (v.code === parseInt(onEdit.generalWorksId)) {
          setGeneralWork(v.code);
          handleEditGeneral(v.code);
        }
      });

      getData.map((v) => {
        if (v.code === parseInt(onEdit.locationId)) {
          setLocation(v.code);
          handleEditLocation(v.code);

          setSubLocation(onEdit.subLocationId);
          handleEditSublocation(onEdit.subLocationId);

          setEquipment(onEdit.equipmentId);
          setDate(onEdit.date);
          setCorePermit(onEdit.corePermitRequired);
          setRemark(onEdit.remarks);
        }
      });

      // Find and set the role
      const existingRole = filteredTechnicianRoles.find(
        (role) => role.code === onEdit.technicianShiftId
      );

      if (existingRole) {
        setSelectedRole(existingRole.code); // Set existing role
      } else {
        // Append the new role to the list if not found
        const newRole = {
          code: onEdit.technicianShiftId,
          name: onEdit.technicianShiftName,
        };
        setFilteredTechnicianRoles((prevRoles) => [...prevRoles, newRole]);
        setSelectedRole(newRole.code); // Set new role
      }

      setShowModal(true);
      setButtonText("Update");
      setIsSubmitted(false);
      setIsUpdated(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const sortedData = [...filteredData].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key]?.toString().toLowerCase();
      const bValue = b[sortConfig.key]?.toString().toLowerCase();
      if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    }
    return 0;
  });

  // Handle column sorting
  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === "asc" ? "desc" : "asc",
    }));
  };

  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <HiMiniArrowsUpDown className="ms-1" size={16} style={{ cursor: "pointer" }} />;
    }
    return sortConfig.direction === "asc" ? (
      <HiMiniArrowUp className="ms-1" size={16} style={{ cursor: "pointer" }} />
    ) : (
      <HiMiniArrowDown className="ms-1" size={16} style={{ cursor: "pointer" }} />
    );
  };
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);


  return (
    <body id="page-top">
      <div id="wrapper">
        <SideMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header />
            <div>
              <div className="container-fluid">
                <div className="card border-0">
                  <div className="card-body pt-0 pl-1">
                    <h5 className="Roles_text"> Daily Work Allocation</h5>
                    <div className="d-flex justify-content-between">
                      <div>
                        <h6 className="mb-0 Sub_role_text">
                          {/* Daily Work Allocation */}
                        </h6>
                      </div>
                      <span
                        class="d-inline-block"
                        tabindex="0"
                        data-toggle="tooltip"
                        title="Assign to work"
                      >
                        <Button
                          className=""
                          variant="primary"
                          onClick={handleModalOpen}
                        >
                          <FontAwesomeIcon
                            icon={faPlus}
                            className="plus_icon mr-1"
                          />
                          Assign Work
                        </Button>
                      </span>
                    </div>
                    <div className="mcrc_hrline"></div>
                    <div
                      className="d-flex justify-content-between align-items-center"
                      style={{ paddingBottom: 20 }}
                    >
                      <div className="d-flex align-items-center">
                        <label className="mr-2">Show </label>
                        <Select
                          options={[
                            { value: 10, label: '10' },
                            { value: 20, label: '20' },
                            { value: 50, label: '50' },
                          ]}
                          value={{
                            value: itemsPerPage,
                            label: String(itemsPerPage),
                          }}
                          onChange={(selected) => {
                            setItemsPerPage(selected.value);
                            setCurrentPage(1);
                          }}
                          isSearchable={false}
                          styles={customstyles}
                        />
                        &nbsp;
                        <label> Entries</label>
                      </div>


                      <div
                        className="d-flex align-items-center"
                        style={{ marginRight: "2%" }}
                      >

                        <div className="search-container">
                          <img
                            src={searchIcon}
                            alt="Search"
                            className="search-icon"
                          />

                          <input
                            type="text"
                            placeholder="Type to Search..."
                            value={searchTerm}
                            onChange={(e) => handleFilter(e.target.value)}
                            className="search-input mr-2"
                          />

                          {searchTerm && (
                            <button
                              type="button"
                              className="search-clear-btn"
                              onClick={() => handleFilter("")}
                            >
                              ×
                            </button>
                          )}
                        </div>
                        &nbsp;
                        <div className="my-2 d-flex w-full justify-content-end gap-2">
                          <button
                            className="btn btn-secondary buttons-excel buttons-html5 mb-0"
                            onClick={exportToExcel}
                          >
                            Download Excel
                          </button>
                          {/* <button
                            className="btn btn-primary"
                            style={{
                              paddingLeft: "3rem",
                              paddingRight: "3rem",
                            }}
                            onClick={handlePrint}
                          >
                            Print
                          </button> */}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="card data_tableCard">
                        <div className="card-body">
                          <div style={{ overflow: "auto" }}>
                            <Table className="table table-bordered  table-striped">
                              <Thead>
                                <Tr>
                                  <Th className="text-center p-1">S.No</Th>
                                  <Th
                                    className="text-center"
                                    onClick={() => handleSort("generalWorks")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      General Works
                                      {renderSortIcon("generalWorks")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center"
                                    onClick={() => handleSort("corePermitRequired")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Core Permit
                                      {renderSortIcon("corePermitRequired")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center"
                                    onClick={() => handleSort("location")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Site
                                      {renderSortIcon("location")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center"
                                    onClick={() => handleSort("subLocation")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Location
                                      {renderSortIcon("subLocation")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center"
                                    onClick={() => handleSort("equipment")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Equipment
                                      {renderSortIcon("equipment")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center"
                                    onClick={() => handleSort("date")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Date
                                      {renderSortIcon("date")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center"
                                    onClick={() => handleSort("technicianShiftName")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Technician Roles
                                      {renderSortIcon("technicianShiftName")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center"
                                    onClick={() => handleSort("remarks")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Remarks
                                      {renderSortIcon("remarks")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center"
                                    onClick={() => handleSort("status")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Status
                                      {renderSortIcon("status")}
                                    </span>
                                  </Th>

                                  <Th className="text-center">Actions</Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {currentItems && currentItems.length > 0 ? (
                                  currentItems.map((item, index) => {
                                    var newDateFormat = moment(item.date).format("DD-MMM-YYYY ");
                                    return (
                                      <Tr key={index}>
                                        <Td className="text-left"> {(currentPage - 1) * itemsPerPage + index + 1}</Td>
                                        <Td className="text-left">
                                          {item.generalWorks}
                                        </Td>
                                        <Td className="text-left">
                                          {item.corePermitRequired}
                                        </Td>
                                        <Td className="text-left">
                                          {item.location}
                                        </Td>
                                        <Td className="text-left">
                                          {item.subLocation}
                                        </Td>
                                        <Td className="text-center">
                                          {item.equipment}
                                        </Td>
                                        <Td className="text-center">
                                          {newDateFormat}
                                        </Td>
                                        <Td className="text-center">
                                          {item.technicianShiftName}
                                        </Td>
                                        <Td className="text-center">
                                          {item.remarks}
                                        </Td>
                                        <Td
                                          className="text-center"
                                          style={{ color: "#FFA500" }}
                                        >
                                          {item.status}
                                        </Td>

                                        <Td
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                          }}
                                        >
                                          <div>
                                            <img
                                              src={Edit_Icon}
                                              alt="Edit"
                                              className="editicon mr-2"
                                              title="Edit Daily Work Allocation"
                                              onClick={() => updatedItems(item)}
                                            />
                                          </div>
                                        </Td>
                                      </Tr>
                                    );
                                  })
                                ) : (
                                  <Tr>
                                    <Td colSpan={11} className="text-center py-4">
                                      {searchTerm?.trim() ? "No Results Found" : "No Data Available"}
                                    </Td>
                                  </Tr>
                                )}
                              </Tbody>

                            </Table>
                          </div>
                        </div>
                        {/* Pagination */}
                        <Pagination
                          currentPage={currentPage}
                          totalItems={sortedData.length}
                          itemsPerPage={itemsPerPage}
                          currentItems={currentItems}
                          onPageChange={handlePageClick}
                        />
                        <div>
                          <Modal
                            show={showModal}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="lg"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title> </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={handleCancel_new}
                              >
                                {" "}
                                X
                              </Button>
                            </Modal.Header>

                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                <span className="modal_title">Assign Work</span>
                              </div>
                              <div className="row">
                                <div className="col-md-6 col-12">
                                  <label
                                    htmlFor="generalListDropdown"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    Type Of Work
                                  </label>
                                  <Select
                                    inputId="generalListDropdown"
                                    styles={modalCustomStyles}
                                    placeholder="Select Type Of Work"
                                    isClearable
                                    value={
                                      generalList
                                        .map((item) => ({
                                          value: item.code,
                                          label: item.name,
                                          data: item,
                                        }))
                                        .find((option) => option.value === generalWork) || null
                                    }
                                    options={generalList.map((item) => ({
                                      value: item.code,
                                      label: item.name,
                                      data: item,
                                    }))}
                                    onChange={(selectedOption) =>
                                      handleGeneralList({
                                        target: {
                                          value: selectedOption ? selectedOption.value : "",
                                          selectedIndex: 0,
                                          options: [
                                            {
                                              getAttribute: (attr) =>
                                                attr === "data-generalWorkName"
                                                  ? selectedOption?.data?.name
                                                  : null,
                                            },
                                          ],
                                        },
                                      })
                                    }
                                    ref={generalSel}
                                  />
                                  <span style={{ color: "red" }}>
                                    {errorTypeOfWork}
                                  </span>
                                </div>

                                <div className="col-md-6 col-12">
                                  <div class="mb-3">
                                    <label
                                      for="exampleInputPassword1"
                                      class="form-label text-sm font-weight-600 mb-0"
                                    >
                                      Core Permit Required ?
                                    </label>
                                    <div className="mt-2">
                                      <label>
                                        {" "}
                                        <input
                                          type="radio"
                                          name="corePermit"
                                          onChange={() => handleChecks("Yes")}
                                          value={corePermit}
                                          checked={corePermit === "Yes"}
                                        />{" "}
                                        Yes{" "}
                                      </label>{" "}
                                      &nbsp;
                                      <label>
                                        {" "}
                                        <input
                                          type="radio"
                                          name="corePermit"
                                          checked={corePermit === "No"}
                                          value={corePermit}
                                          onChange={() => handleChecks("No")}
                                        />{" "}
                                        No
                                      </label>
                                    </div>
                                    <span style={{ color: "red" }}>
                                      {errcorepermit}
                                    </span>
                                  </div>
                                </div>
                                <div className="col-md-6 col-12">
                                  <label
                                    htmlFor="siteDropdown"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    Site <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <Select
                                    inputId="siteDropdown"
                                    styles={modalCustomStyles}
                                    placeholder="Select Site"
                                    isClearable
                                    value={
                                      getData
                                        .map((item) => ({
                                          value: item.code,
                                          label: item.name,
                                          data: item,
                                        }))
                                        .find((option) => option.value === location) || null
                                    }
                                    options={getData.map((item) => ({
                                      value: item.code,
                                      label: item.name,
                                      data: item,
                                    }))}
                                    onChange={(selectedOption) =>
                                      handleLocation({
                                        target: {
                                          value: selectedOption ? selectedOption.value : "",
                                          selectedIndex: 0,
                                          options: [
                                            {
                                              getAttribute: (attr) =>
                                                attr === "data-location"
                                                  ? selectedOption?.data?.name
                                                  : null,
                                            },
                                          ],
                                        },
                                      })
                                    }
                                  />
                                  <span style={{ color: "red" }}>
                                    {errLocation}
                                  </span>
                                </div>

                                <div className="col-md-6 col-12">
                                  <label
                                    htmlFor="subLocationDropdown"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    Location <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <Select
                                    inputId="subLocationDropdown"
                                    styles={modalCustomStyles}
                                    placeholder="Select Location"
                                    isClearable
                                    value={
                                      getSubLocationsArray
                                        .map((item) => ({
                                          value: item.code,
                                          label: item.name,
                                          data: item,
                                        }))
                                        .find((option) => option.value === subLocation) || null
                                    }
                                    options={getSubLocationsArray.map((item) => ({
                                      value: item.code,
                                      label: item.name,
                                      data: item,
                                    }))}
                                    onChange={(selectedOption) =>
                                      handleSubLocation({
                                        target: {
                                          value: selectedOption ? selectedOption.value : "",
                                          selectedIndex: 0,
                                          options: [
                                            {
                                              getAttribute: (attr) =>
                                                attr === "data-subLocationName"
                                                  ? selectedOption?.data?.name
                                                  : null,
                                            },
                                          ],
                                        },
                                      })
                                    }
                                  />
                                  <span style={{ color: "red" }}>
                                    {errSubLocation}
                                  </span>
                                </div>
                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    htmlFor="equipmentDropdown"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    Equipment <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <Select
                                    inputId="equipmentDropdown"
                                    styles={modalCustomStyles}
                                    placeholder="Select Equipment"
                                    isClearable
                                    value={
                                      getEquipments
                                        .map((item) => ({
                                          value: item.code,
                                          label: item.name,
                                          data: item,
                                        }))
                                        .find((option) => option.value === equipment) || null
                                    }
                                    options={getEquipments.map((item) => ({
                                      value: item.code,
                                      label: item.name,
                                      data: item,
                                    }))}
                                    onChange={(selectedOption) =>
                                      handleEquipment({
                                        target: {
                                          value: selectedOption ? selectedOption.value : "",
                                          selectedIndex: 0,
                                          options: [
                                            {
                                              getAttribute: (attr) =>
                                                attr === "data-equipmentName"
                                                  ? selectedOption?.data?.name
                                                  : null,
                                            },
                                          ],
                                        },
                                      })
                                    }
                                  />
                                  <span style={{ color: "red" }}>
                                    {errEquipment}
                                  </span>
                                </div>
                                <div className="col-md-6 col-12 mt-2">
                                  <div className="mb-3">
                                    <label
                                      htmlFor="datePicker"
                                      className="form-label text-sm font-weight-600 mb-0"
                                    >
                                      Date <span style={{ color: "red" }}>*</span>
                                    </label>

                                    <div className="input-group w-100 mt-2">
                                      <DatePicker
                                        selected={date ? new Date(date) : null}
                                        onChange={(selectedDate) =>
                                          handleDate({
                                            target: {
                                              value: selectedDate
                                                ? `${selectedDate.getFullYear()}-${String(
                                                  selectedDate.getMonth() + 1
                                                ).padStart(2, "0")}-${String(
                                                  selectedDate.getDate()
                                                ).padStart(2, "0")}`
                                                : "",
                                            },
                                          })
                                        }
                                        dateFormat="dd-MMM-yyyy"
                                        placeholderText="dd-mm-yyyy"
                                        customInput={<CustomDatePickerInput />}
                                        minDate={new Date(getCurrentDate())}
                                      />
                                    </div>
                                  </div>

                                  <span style={{ color: "red" }}>
                                    {errDate}
                                  </span>
                                </div>
                                <div className="col-md-6 col-12">
                                  <label
                                    htmlFor="technicianRoleDropdown"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    Technician Role <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <Select
                                    inputId="technicianRoleDropdown"
                                    styles={modalCustomStyles}
                                    placeholder="Select Technician Role"
                                    isClearable
                                    value={
                                      technicianRolesList
                                        .map((role) => ({
                                          value: role.code,
                                          label: role.name,
                                          data: role,
                                        }))
                                        .find((option) => option.value === selectedRole) || null
                                    }
                                    options={technicianRolesList.map((role) => ({
                                      value: role.code,
                                      label: role.name,
                                      data: role,
                                    }))}
                                    onChange={(selectedOption) =>
                                      handleTechnicianRoleList({
                                        target: {
                                          value: selectedOption ? selectedOption.value : "",
                                          selectedIndex: 0,
                                          options: [
                                            {
                                              getAttribute: () => selectedOption?.data?.name || null,
                                            },
                                          ],
                                        },
                                      })
                                    }
                                  />

                                  <span style={{ color: "red" }}>
                                    {errTechnicianRole}
                                  </span>
                                </div>


                                <div className="col-md-6 col-12">
                                  <div class="mb-3">
                                    <label
                                      for="exampleInputPassword1"
                                      class="form-label text-sm font-weight-600 mb-0"
                                    >
                                      Remarks
                                    </label>
                                    <textarea
                                      class="form-control"
                                      style={{ height: 115 }}
                                      id="textAreaExample1"
                                      rows="2"
                                      value={remark}
                                      // onChange={(e) =>
                                      //   setRemark(e.target.value)
                                      // }
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        const formattedValue = value.replace(
                                          /(^|\s)([a-z])/g,
                                          (match, space, char) => space + char.toUpperCase()
                                        );
                                        setRemark(formattedValue);
                                      }}
                                    ></textarea>
                                  </div>
                                </div>
                              </div>
                              &nbsp;
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Button
                                  variant="primary"
                                  className="btnn"
                                  onClick={() =>
                                    buttonText === "Submit"
                                      ? handleSubmit(
                                        selectedItem,
                                        selectedIndex
                                      )
                                      : handleUpdate(
                                        id,
                                        selectedItem,
                                        selectedIndex
                                      )
                                  }
                                >
                                  {buttonText}
                                </Button>
                                <div style={{ width: "20px" }}></div>
                                <Button
                                  variant="danger"
                                  className="btnn"
                                  onClick={handleCancel_new}
                                >
                                  Cancel
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            className="modalBlur"
                            show={showPopup}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">Assign Work</span>
                              </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    Are You Sure, Do You Want Close This Window
                                    ?
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleClose}
                                >
                                  Yes
                                </Button>
                                &nbsp;&nbsp;
                                <Button
                                  variant="danger"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleCancel}
                                >
                                  No
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            show={showWarningPopup}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">Assign Work</span>
                              </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    Are You Sure, Do You want close the Window ?
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleClose}
                                >
                                  Yes
                                </Button>
                                &nbsp;&nbsp;
                                <Button
                                  variant="danger"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleCancel}
                                >
                                  No
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            show={showResponsePopup}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                <span className="modal_title">
                                  Daily Work Allocation
                                </span>
                              </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    {submitResponse}
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleresponse}
                                >
                                  Okay
                                </Button>
                                &nbsp;&nbsp;
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {isLoading && (
                  <Loader_Bulk
                    loading={isLoading}
                    message={"Fetching Data. Please Wait..!"}
                    loderimage={loaderImage}
                  />
                )}
              </div>
            </div>
          </div>
          {/* ...End of Main Content...*/}

          {/* ...Footer...*/}
          <Footer />
          {/* ... End of Footer...  */}
        </div>
      </div>
      {/*  <!-- End of Page Wrapper -->

                    <!-- Scroll to Top Button--> */}
      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>

      {/*  <!-- Logout Modal--> */}
      <Logout />
    </body >
  );
};

export default DailyWorkAllocation;
